import React from 'react';
import ResearchArea from './ResearchArea';
import './CoreResearchAreas.css';

import effectImg from '../../images/research-areas-background-effect.png';

function CoreResearchAreasSection() {
  return (
    <header id="CoreResearchAreasSection">
      <img id="right-effect" src={effectImg} alt="" />
      <div className="third-screen" id="titleDiv">
        <h2 id="title">
        Development of innovative solutions based on:
        </h2>
      </div>

      <div className="third-screen" id="areasDiv">
        <ResearchArea area="EXTENDED REALITY" />
        <ResearchArea area="COMPUTER VISION" />
        <ResearchArea area="NATURAL INTERACTION" />
      </div>
    </header>
  );
}

export default CoreResearchAreasSection;
